// Get Recommended Creators
export const GET_RECOMMENDED_CREATORS_REQUEST = 'GET_RECOMMENDED_CREATORS_REQUEST';
export const GET_RECOMMENDED_CREATORS_DONE = 'GET_RECOMMENDED_CREATORS_DONE';
export const GET_RECOMMENDED_CREATORS_FAILED = 'GET_RECOMMENDED_CREATORS_FAILED';
export const GET_RECOMMENDED_CREATORS_RESET = 'GET_RECOMMENDED_CREATORS_RESET';